module.exports = "<v-list class=\"sidebar-apartment\">\n  <v-list-tile-content class=\"pa-1\" v-for=\"(item, index) in coDocuments\" :key=\"index\">\n    <a :href=\"item.link\" target=\"_blank\" class=\"sidebar-apartment__item white--text\" v-html=\"item.name\"></a>\n  </v-list-tile-content>\n  <v-list-tile-content>\n    <router-link :to=\"path\" class=\"white--text none-underline--link sidebar-apartment__button-see-more\">\n      <span class=\"ma-1\">{{$t('BTN_SEEMORE')}}</span>\n    </router-link>\n  </v-list-tile-content>\n</v-list>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/block/components/block-sidebar-widget-documents/template.html
// module id = 8mF1
// module chunks = 0